enum SidebarItems {
    Home = "home",
    Trending = "trending",
    Explore = "explore",
    Search = "search",
    Favorites = "favorites",
    None = "none"
}

export default SidebarItems;